<template>
  <div>
    <modal-login v-if="loginModal.active" :handle-close-click="hideLoginModal" />
    <modal-error v-if="errorModal.active" :handle-close-click="hideErrorModal" />
  </div>
</template>

<script>
// @flow
import { mapActions, mapState } from 'vuex'
import modalError from 'app/components/modals/modal-error.vue'
import modalLogin from 'app/components/modals/modal-login.vue'

export default {
  components: { modalError, modalLogin },
  computed: {
    ...mapState({
      loginModal: (state: State) => state.loginModal,
      errorModal: (state: State) => state.errorModal,
    }),
  },
  methods: {
    ...mapActions(['hideErrorModal', 'hideLoginModal']),
  },
}
</script>
